export const professional = ({ professional }) => professional



// WEBPACK FOOTER //
// ./src/store/getters/professional.js